/**
 * @author      joseph.murphy@zumper.com (murph)
 * @copyright   Copyright (c) 2022, Zumper
 */

// https://chakra-ui.com/docs/styled-system/theming/component-style#styling-single-part-components

import type { ComponentStyleConfig } from '@chakra-ui/theme'
import { SystemStyleFunction, mode } from '@chakra-ui/theme-tools'

const normalizeSpacing = {
  padding: 0,
  margin: 0,
}

const variantBody24Reg: SystemStyleFunction = (props) => ({
  color: mode('gray.900', 'gray.0')(props),
  fontFamily: 'body',
  fontSize: 'xl',
  fontWeight: 'normal',
  lineHeight: '120%',
  ...normalizeSpacing,
})

const variantBody20Reg: SystemStyleFunction = (props) => ({
  color: mode('gray.900', 'gray.0')(props),
  fontFamily: 'body',
  fontSize: 'lg',
  fontWeight: 'normal',
  lineHeight: '120%',
  ...normalizeSpacing,
})

const variantBody16Bold: SystemStyleFunction = (props) => ({
  color: mode('gray.900', 'gray.0')(props),
  fontFamily: 'body',
  fontSize: 'md',
  fontWeight: 'extrabold',
  lineHeight: '150%',
  ...normalizeSpacing,
})

const variantBody16Md: SystemStyleFunction = (props) => ({
  color: mode('gray.900', 'gray.0')(props),
  fontFamily: 'body',
  fontSize: 'md',
  fontWeight: 'medium',
  lineHeight: '150%',
  ...normalizeSpacing,
})

const variantBody16Reg: SystemStyleFunction = (props) => ({
  color: mode('gray.900', 'gray.0')(props),
  fontFamily: 'body',
  fontSize: 'md',
  fontWeight: 'normal',
  lineHeight: '150%',
  ...normalizeSpacing,
})

const variantBody14Bold: SystemStyleFunction = (props) => ({
  color: mode('gray.900', 'gray.0')(props),
  fontFamily: 'body',
  fontSize: 'sm',
  fontWeight: 'extrabold',
  lineHeight: '150%',
  ...normalizeSpacing,
})

const variantBody14Md: SystemStyleFunction = (props) => ({
  color: mode('gray.900', 'gray.0')(props),
  fontFamily: 'body',
  fontSize: 'sm',
  fontWeight: 'medium',
  lineHeight: '150%',
  ...normalizeSpacing,
})

const variantBody14Reg: SystemStyleFunction = (props) => ({
  color: mode('gray.900', 'gray.0')(props),
  fontFamily: 'body',
  fontSize: 'sm',
  fontWeight: 'normal',
  lineHeight: '150%',
  ...normalizeSpacing,
})

const variantLabel14Caps: SystemStyleFunction = (props) => ({
  color: mode('gray.900', 'gray.0')(props),
  letterSpacing: '1.96px',
  fontFamily: 'body',
  fontSize: 'sm',
  fontWeight: 'extrabold',
  lineHeight: '150%',
  textTransform: 'uppercase',
  ...normalizeSpacing,
})

const variantLabel12Caps: SystemStyleFunction = (props) => ({
  color: mode('gray.900', 'gray.0')(props),
  letterSpacing: '1.68px',
  fontFamily: 'body',
  fontSize: 'xs',
  fontWeight: 'medium',
  lineHeight: '150%',
  textTransform: 'uppercase',
  ...normalizeSpacing,
})

const variantLabel12Reg: SystemStyleFunction = (props) => ({
  color: mode('gray.900', 'gray.0')(props),
  fontFamily: 'body',
  fontSize: 'xs',
  fontWeight: 'normal',
  lineHeight: '150%',
  ...normalizeSpacing,
})

const baseStyle: SystemStyleFunction = (props) => ({
  color: mode('gray.900', 'gray.0')(props),
  fontFamily: 'body',
  fontSize: 'md',
  fontWeight: 'normal',
  ...normalizeSpacing,
})

// These variants are curated by Design,
// no changes or updates should be made
// without consulting the Design team.
export const variantsText = {
  body24Reg: variantBody24Reg,
  body20Reg: variantBody20Reg,
  body16Bold: variantBody16Bold,
  body16Md: variantBody16Md,
  body16Reg: variantBody16Reg,
  body14Bold: variantBody14Bold,
  body14Md: variantBody14Md,
  body14Reg: variantBody14Reg,
  label14Caps: variantLabel14Caps,
  label12Caps: variantLabel12Caps,
  label12Reg: variantLabel12Reg,
}

export const Z4Text: ComponentStyleConfig = {
  baseStyle,
  variants: variantsText,
}
